<template>
  <b-dropdown aria-role="list" class="actions" :position="position">
    <button class="button action" slot="trigger">
      <span class="text">{{ $t('button.action') }}</span>
      <b-icon :icon="'sort-down'"></b-icon>
    </button>
    <slot></slot>
  </b-dropdown>
</template>

<script>
export default {
  name: 'Actions',
  props: {
    position: {
      type: String,
      default: null
    }
  }
}
</script>

<style lang="scss">
.dropdown.actions {
  height: 1.25rem;
  .button {
    padding: 0rem;
    padding-right: 0.625rem;
    height: 1.25rem;
    &.action {
      border: 0.0625rem solid #ccc;
      background-color: white;
      .icon {
        color: #686868;
      }
    }
    .text {
      padding-right: 0.625rem;
      padding-left: 0.625rem;
    }
    .icon {
      height: 1rem;
      border-bottom-right-radius: 0.25rem;
      border-top-right-radius: 0.25rem;
      border-left: 0.0625rem solid #ccc;
      .fa-sort-down {
        padding-bottom: 0.625rem;
      }
      .fa-sort-up {
        padding-top: 0.625rem;
      }
    }
  }
  .dropdown-menu {
    padding-top: 0.625rem;
  }
}
</style>
